import { Component, input } from '@angular/core';
import { DatatableConfig } from '../types/datatable-configuration';

@Component({
  selector: 'table-datatable',
  template: '',
})
export class DatatableMock<T extends object> {
  data = input.required<T[]>();
  datatableConfig = input.required<DatatableConfig<T>>();
  isLoading = input<boolean>();
}
